import { useSyncExternalStore } from 'react';

const query = '(max-width: 767px)';
const subscribe = (notify) => {
    const media = window.matchMedia(query);
    media.addEventListener('change', notify);
    return () => media.removeEventListener('change', notify);
};
const getSnapshot = () => window.matchMedia(query).matches;

// Use the same breakpoint as mobile.css, including resized windows and WebViews.
export default function useMobileSchedule() {
    return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
